/**
 * Politique cookies — texte JURIDIQUE VALIDÉ. Ne pas reformuler.
 *
 * {{DUREE_SESSION}} est remplacé par la durée RÉELLE du cookie de
 * session lue dans le code d'authentification (voir content/legal/index.js).
 */
const COOKIES_FR = String.raw`
# Politique cookies

**Archer · archer.law**
Dernière mise à jour : {{DATE_MISE_EN_LIGNE}}

*Le présent document est disponible en français, néerlandais et anglais. En cas de divergence entre les versions linguistiques, la version française prévaut.*

## 1. C'est quoi, un cookie ?

Un cookie est un petit fichier déposé sur votre appareil lors de la visite d'un site. Certains sont indispensables au fonctionnement du site ; d'autres servent à mesurer l'audience ou à la publicité et ne peuvent être déposés qu'avec votre **consentement préalable** (art. 129 de la loi belge du 13 juin 2005 relative aux communications électroniques et RGPD).

## 2. Les cookies que nous utilisons

### 2.1. Cookies strictement nécessaires : pas de consentement requis

Ils permettent au site de fonctionner et ne peuvent pas être désactivés :

| Cookie | Finalité | Durée |
|---|---|---|
| Session / authentification | Vous maintenir connecté à votre compte | Session ou {{DUREE_SESSION}} |
| Sécurité (anti-CSRF) | Protéger les formulaires contre les usurpations | Session |
| Préférences | Mémoriser votre langue et vos choix d'interface | 12 mois |
| Consentement | Mémoriser vos choix cookies | 6 mois |

### 2.2. Cookies publicitaires et de mesure : soumis à votre consentement

Nous utilisons (ou prévoyons d'utiliser) des traceurs de plateformes publicitaires pour mesurer l'efficacité de nos campagnes et diffuser des publicités pertinentes :

| Traceur | Fournisseur | Finalité |
|---|---|---|
| Pixel TikTok | TikTok Technology Limited | Mesure des campagnes, publicité ciblée |
| Pixel Meta | Meta Platforms Ireland Ltd | Mesure des campagnes, publicité ciblée |

**Ces traceurs ne sont jamais activés avant votre consentement.** Tant que vous n'avez pas cliqué « Accepter », aucun script publicitaire n'est chargé et aucune donnée n'est transmise à ces plateformes. Les données éventuellement collectées après consentement (pages vues, événements de conversion, identifiants techniques) sont traitées par ces plateformes selon leurs propres politiques, y compris hors de l'Union européenne.

## 3. Vos choix

Lors de votre première visite, un bandeau vous propose d'**Accepter** ou de **Refuser** les cookies non nécessaires, avec le même niveau de simplicité pour les deux choix. Refuser ne dégrade pas votre accès au Service.

Vous pouvez modifier votre choix à tout moment via le lien « **Gérer mes cookies** » en pied de page. Votre choix est conservé 6 mois, après quoi il vous est redemandé.

Vous pouvez également configurer votre navigateur pour bloquer ou supprimer les cookies ; le blocage des cookies strictement nécessaires peut toutefois empêcher la connexion à votre compte.

## 4. Contact

Pour toute question relative aux cookies et traceurs : bonjour@archer.law.
`;

export default COOKIES_FR;
